document.addEventListener('turbo:load', (event) => {
  const button = document.querySelector('#menu-button');
  const closeButton = document.querySelector('#close-menu');
  const menu = document.querySelector('#sidebar-menu');

  button?.addEventListener('click', () => {
    menu.classList.toggle('hidden');
  });

  closeButton?.addEventListener('click', () => {
    menu.classList.toggle('hidden');
  });
});
